<template>
    <el-tabs type="border-card" :stretch="true">
            <el-tab-pane label="Base Info">
                <el-form label-width="150px" class="detail">
                    <el-form-item label="Offer Id">
                        <div>{{result.offer_id}}</div>
                    </el-form-item>
                    <el-form-item label="Offer Name">
                        <div>{{result.offer_name}}</div>
                    </el-form-item>
                    <el-form-item label="Adv Offer Id">
                        <div>{{result.adv_offer_id}}</div>
                    </el-form-item>
                    <el-form-item label="Adv Id">
                        <div>{{result.adv_id}}</div>
                    </el-form-item>
                    <el-form-item label="Adv Name">
                        <div>{{result.adv_name}}</div>
                    </el-form-item>
                    <!-- <el-form-item label="Affilitest">
                        <div class="affilitest-button-result">
                            <el-button size="medium" type="primary" @click="affilitestJump(result)">Jump</el-button>
                            <mm-trace-result :histories="result.trace.histories" :stop_reason="result.trace.stop_reason" :redirections="result.trace.redirections"/>
                            <span>{{dateType(result.trace.updated_at)}}</span>
                        </div>
                    </el-form-item> -->
                    <el-form-item label="Manager">
                        <div>{{result.offer_bd}}</div>
                    </el-form-item>
                    <el-form-item label="Status">
                        <div :class="'status-'+result.status">{{result.manual_status&&result.status.toUpperCase()}}</div>
                    </el-form-item>
                    <el-form-item label="Manual Status">
                        <div :class="'status-'+result.manual_status">{{result.manual_status&&result.manual_status.toUpperCase()}}</div>
                    </el-form-item>
                    <el-form-item label="Adv Tracking Link">
                        <div>{{result.adv_tracking_link}}</div>
                    </el-form-item>
                    <el-form-item label="Adv IMP Link">
                        <div>{{result.impression_link}}</div>
                    </el-form-item>
                    <el-form-item label="Pricing Model">
                        <div>{{result.pricing_model}}</div>
                    </el-form-item>
                    <el-form-item label="Offer Price">
                        <div>{{result.offer_price}}</div>
                    </el-form-item>
                    <el-form-item label="Payable Event">
                    <el-table :data="result.events">
                        <el-table-column prop="event_name" label="Event Name"></el-table-column>
                        <el-table-column prop="event_value" label="Event Value"></el-table-column>
                        <el-table-column prop="payout" label="Payout"></el-table-column>
                    </el-table>
                    </el-form-item>
                    <el-form-item label="Traffic Type">
                        <div>{{result.traffic_type}}</div>
                    </el-form-item>
                    <el-form-item label="Platform">
                        <div>{{result.platform}}</div>
                    </el-form-item>
                </el-form>
                
            </el-tab-pane>

            <el-tab-pane label="App Info">
                <el-form label-width="150px" class="detail">
                    <el-form-item label="Category">
                        <div>{{result.category}}</div>
                    </el-form-item>
                    <el-form-item label="Geo">
                        <div>{{result.geo}}</div>
                    </el-form-item>
                    <el-form-item label="State">
                        <div>{{result.state}}</div>
                    </el-form-item>
                    <el-form-item label="City">
                        <div>{{result.city}}</div>
                    </el-form-item>
                    <el-form-item label="Offer Kpi">
                        <div v-html="result.kpi"></div>
                    </el-form-item>
                    <el-form-item label="App Name">
                        <div>{{result.app_name}}</div>
                    </el-form-item>
                    <el-form-item label="Package Id">
                        <div>{{result.package_id}}</div>
                    </el-form-item>
                    <el-form-item label="Preview Url">
                        <a :href="result.preview_url" target="_blank" >{{result.preview_url}}</a>
                    </el-form-item>
                    <el-form-item label="Icon Url">
                        <div>{{result.icon_addr}}</div>
                    </el-form-item>
                    <el-form-item label="App Description">
                        <div v-html="result.description"></div>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="Traffic Control">
                <el-form label-width="150px" class="detail">
                    <el-form-item label="White Only">
                        <div>{{result.whiteOnly}}</div>
                    </el-form-item>
                    <el-form-item label="Daily Cap">
                        <div>{{result.daily_cap}}</div>
                    </el-form-item>
                    <el-form-item label="Daily Click">
                        <div>{{result.daily_click}}</div>
                    </el-form-item>
                    <el-form-item label="Time Zone">
                        <div>{{result.timezone}}</div>
                    </el-form-item>
                    <el-form-item label="To Active Time">
                        <div>{{result.toActiveTime}}</div>
                    </el-form-item>
                    <el-form-item label="To Pause Time">
                        <div>{{result.toPauseTime}}</div>
                    </el-form-item>
                    <el-form-item label="Exclude Subs">
                        <div style="">{{result.exclude_sub}}</div>
                    </el-form-item>
                    <el-form-item v-for="sub of custom_subs" :label="'Custom Subs '+sub.channel_id" :key="sub.channel_id">
                        <div v-if="sub.channel.whiteOnly&&!sub.camp.whiteOnly&&sub.channel.white_subs">
                            Channel White Subs:<br/>{{sub.channel.white_subs}}
                        </div>
                        <div v-else-if="!sub.channel.whiteOnly&&!sub.camp.whiteOnly&&sub.channel.block_subs">
                            Channel Block Subs:<br/>{{sub.channel.block_subs}}
                        </div>
                        <div v-if="sub.camp.whiteOnly&&sub.camp.white_subs">
                            Camp White Subs:<br/>{{sub.camp.white_subs}}
                        </div>
                        <div v-if="!sub.camp.whiteOnly&&!sub.channel.whiteOnly&&sub.camp.block_subs">
                            Camp Block Subs:<br/>{{sub.camp.block_subs}}
                        </div>
                    </el-form-item>
                    <el-form-item label="Remark">
                        <div v-html="result.remark && result.remark.replace(/\n/g, '<br/>')"></div>
                    </el-form-item>

                </el-form>
            </el-tab-pane>
            <el-tab-pane label="Campaign Links">
                <el-form label-width="150px" class="detail">
                    <el-form-item v-for="camp_id in result.camp_ids" :label="camp_id.toString()" :key="camp_id">
                        <a :href="result.camp_link+camp_id" target="_blank">{{result.camp_link+camp_id}}</a>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="Channel Info">
                <el-form label-width="150px" class="detail">
                    <el-form-item label="Show Kpi">
                        <el-switch v-model="show_kpi"/>
                    </el-form-item>
                    <el-form-item v-for="camp_id in result.camp_ids" :label="camp_id.toString()" :key="camp_id">
                        <div class="channel-info">
                            <span>
                                <div>payout: {{result.channel_info[camp_id].payout}}$</div>
                                <div>caps: {{result.channel_info[camp_id].caps}}</div>
                            </span>
                            <span>
                                <el-button size="medium" type="primary" @click="copyInfo(camp_id)">Copy {{camp_id}}</el-button>
                            </span>
                        </div>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
    </el-tabs>

</template>
<script>
export default {
	data() {
		return {
			detail: "hhh",
			result: {},
			custom_subs: {},
			show_kpi: true,
		};
	},
	methods: {
		async loaddata(v) {
			this.result = await this.$post("/offer/detail", { id: v });
            if (this.result.description) {
                this.result.description = this.result.description.replace(/\n/g, '<br/>');
            }
            if (this.result.kpi) {
                this.result.kpi = this.result.kpi.replace(/\n/g, '<br/>');
            }
			this.custom_subs = this.result.custom_subs;
			for (const sub of this.custom_subs) {
				for (const type of [ 'channel', 'camp' ]) {
					if (JSON.stringify(sub[type]) !== '{}') {
						if (sub[type].whiteOnly) {
							sub[type].white_subs = sub[type].white_subs ? sub[type].white_subs : '';
						} else {
							sub[type].block_subs = sub[type].block_subs ? sub[type].block_subs : '';
						}
					}
				}
			}
		},
		async copyInfo(channel_id) {
			const default_kpi = 'No fraud, No bot, D1RR>35%';
			const reg1 = /(<(\/\w+|\w+|\w+\s{0,}\/)>)/g;
			const reg2 = /(&\w{2,};)/g;
			let kpi = this.result.kpi.replace(default_kpi, '').replace(reg1, `\t`).replace(reg2, `\t`);
			if (!this.show_kpi) {
				kpi = '';
			}
			let text = `${this.result.offer_id}\r` +
            `${this.result.offer_name}-${this.result.channel_info[channel_id].payout}$\r` +
            `${this.result.preview_url}\r\r` +
            `${this.result.camp_link + channel_id}\r`
			if (this.result.imp_link) {
				text += `\rimpression link: ${this.result.imp_link + channel_id}\r`;
			}
            text += `\rAPPROVED;\r`;
			await this.$copyText((text));
			this.$message({
				type:'success',
				message:'Copied ' + channel_id + ' success',
			})
		},
		async affilitestJump(offer) {
			if (offer.platform === 'others') {
				this.$message({
					message: 'platform type can not be others',
				})
				return;
			}
			const device = offer.platform === 'ios' ? 'iphone' : offer.platform;
			const post = {
				link: offer.adv_tracking_link,
				device: device,
				geo: offer.geos[0],
				offer: {
					offer_id: offer.offer_id,
					adv_offer_id: offer.adv_offer_id,
					adv_id: offer.adv_id,
				}
			};
			this.result.trace = await this.$post('/traceLog/affilitestJump', post);
            
		},
		dateType(date) {
			if (!date) {
				return '';
			}
			date = new Date(date);
			return ' UPDATED: ' + this.$utils.date_format(date, 'YYYY-MM-DD hh:mm:ss');
		}
	},
	props: ["id"],
	watch: {
		id(v) {
			this.loaddata(v);
		}
	},
	mounted() {
		this.loaddata(this.id);
	}
};
</script>


<style scoped>
div{
        overflow-wrap: break-word;
}
.detail-tab {
	background-color: rgb(175, 187, 236);
	height: 30px;
	width: 100%;
	text-align: center;
	vertical-align: bottom;
}
.el-form-item {
	/* margin:0 10px 0 10px; */
	width: 100%;
	border-style: solid;
	border-color: rgb(230, 230, 230);
	border-width: 0px 0px 1px 0px;
}
.channel-info {
    display: flex;
    justify-content: space-between;
}
.affilitest-button-result {
    display: flex;
    justify-content: space-around;
}
</style>
